var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { styled } from '@creditas-ui/system';
import { getTypography, media } from '@creditas-ui/utilities';
import { Box } from '@creditas-ui/layout';
var setVariantByBreakpoint = (variant, breakpoint, theme, family) => {
  if (breakpoint === '_') {
    return getTypography(variant, family)({
      theme
    });
  }
  return "\n    ".concat(media.up(breakpoint), " {\n      ").concat(getTypography(variant, family)({
    theme
  }), "\n    }\n  ");
};
var getTypographyByBreakpoint = (breakpointVariants, theme, family) => {
  var breakpointVariantsList = Object.entries(breakpointVariants);
  return breakpointVariantsList.map(value => {
    var [breakpoint, variant] = value || [];
    return setVariantByBreakpoint(variant, breakpoint, theme, family);
  });
};
var base = _ref => {
  var {
    theme,
    variant,
    family
  } = _ref;
  if (typeof variant === 'string') {
    return getTypography(variant, family)({
      theme
    });
  }
  if (typeof variant === 'object') {
    return getTypographyByBreakpoint(variant, theme, family);
  }
  return '';
};
var TypographyElement = styled(Box.withComponent('p', process.env.NODE_ENV === "production" ? {
  target: "e1ledf4j0"
} : {
  target: "e1ledf4j0",
  label: "TypographyElement"
}))(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), base);
export { TypographyElement };
//# sourceMappingURL=Typography.style.js.map